module.exports = "<div class=\"container-fluid\">\n    <div class=\"row\">\n        <div class=\"col-12\">\n            <h3>\n                <i class=\"fas fa-envelope-open text-warning\"></i>\n                Add message\n            </h3>\n            <hr class=\"mt-0\"/>\n        </div>\n    </div>\n    <messages [settings]=\"settings\" [messageCollection]=\"messageCollection\" (done)=\"done()\" (reload)=\"done()\"></messages>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/messages/add.component.html
// module id = 600
// module chunks = 1